// extracted by mini-css-extract-plugin
export default {"gridForm":"ColumnMapping_gridForm__hxJVL"};